import { createPinia } from 'pinia'

import useConstant_cn from './modules/constant-cn'
import useConstant_en from './modules/constant-en'

import useApp from './modules/app'
import app from './modules/app'

export const pinia = createPinia()

const lang = navigator.language// 获取浏览器默认语言。
const language = lang === 'zh-CN' ? 'cn' : 'en'

// const storeObj = {
//   constant: 'cn'===language ? useConstant_cn : useConstant_en,
//   app: useApp
// }

const storeObj = {
  constant: useConstant_cn,
  app: useApp
}

export function useStore (key) {
  return storeObj[key]()
}

export async function initializeStores () {
  const constantStore = useConstant_cn(pinia)

  if (typeof constantStore.loadDavinciData === 'function') {
    await constantStore.loadDavinciData()
  }
}

export default pinia
